import React from 'react';
import { Text, View, SafeAreaView } from 'react-native';
import Icon from 'LocalGluons/components/Icon';
import { Device } from 'DeviceUtils';
import type { StyleMap } from 'Types';
import defaultStyles from './styles';

interface MiniPlayerDetailProps {
    style?: StyleMap;
    isPaused: boolean;
    onPlayPausePress: () => void;
    onClose: () => void;
    title: string;
    subtitle?: string;
}

const MiniPlayerDetail = ({
    style,
    isPaused,
    onPlayPausePress,
    onClose,
    title,
    subtitle
}: MiniPlayerDetailProps): React.ReactElement => (
    <SafeAreaView style={style}>
        <View style={[defaultStyles.container, style]}>
            <View style={defaultStyles.bottomContainer}>
                <Text style={defaultStyles.title} numberOfLines={Device.isTabletOrWeb ? 2 : 1}>
                    {title}
                </Text>
                {Device.isTabletOrWeb && (
                    <Icon
                        hitSlop={{ top: 35, bottom: 35, left: 35, right: 35 }}
                        onPress={onClose}
                        name="close"
                        testID="close_button"
                        // useGestureHandler
                    />
                )}
            </View>
            <View style={defaultStyles.bottomContainer}>
                <Text style={defaultStyles.subtitle} numberOfLines={!Device.isTabletOrWeb ? 2 : 1}>
                    {subtitle}
                </Text>

                <Icon
                    hitSlop={{ top: 35, bottom: 35, left: 35, right: 35 }}
                    onPress={onPlayPausePress}
                    name={isPaused ? 'play_arrow_player' : 'player_pause'}
                    testID="play/pause_button"
                    // useGestureHandler
                />
            </View>
        </View>
    </SafeAreaView>
);

export default MiniPlayerDetail;
